export const showNotLoggedModal = (showing = false) => {
    return {
      type : 'NOT_LOGGED_MODAL_SHOW',
      showing 
    }
  };
  